/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `BB_IMPORT` - BB_IMPORT
 *   * `CEPRO_IMPORT` - CEPRO_IMPORT
 *   * `INITIAL_IMPORT` - INITIAL_IMPORT
 *   * `DTM` - DTM
 *   * `DTM_KAD` - DTM_KAD
 *   * `GP` - GP
 *   * `CHECK` - CHECK
 *   * `DMVS_GAD_CHECK` - DMVS_GAD_CHECK
 *   * `DMVS_DTI` - DMVS_DTI
 *   * `DMVS_GAD` - DMVS_GAD
 *   * `CROSS_OWNER` - CROSS_OWNER
 *   * `CROSS_WORKER` - CROSS_WORKER
 *   * `SVU_WORKER` - SVU_WORKER
 *   * `SVU_OWNER` - SVU_OWNER
 *   * `SVU_CROSS_WORKER` - SVU_CROSS_WORKER
 *   * `SVU_CROSS_OWNER` - SVU_CROSS_OWNER
 *   * `GP_BRNO` - GP_BRNO
 * ```
 */
export const FlowEnum = {
  BB_IMPORT: 'BB_IMPORT',
  CEPRO_IMPORT: 'CEPRO_IMPORT',
  INITIAL_IMPORT: 'INITIAL_IMPORT',
  DTM: 'DTM',
  DTM_KAD: 'DTM_KAD',
  GP: 'GP',
  CHECK: 'CHECK',
  DMVS_GAD_CHECK: 'DMVS_GAD_CHECK',
  DMVS_DTI: 'DMVS_DTI',
  DMVS_GAD: 'DMVS_GAD',
  CROSS_OWNER: 'CROSS_OWNER',
  CROSS_WORKER: 'CROSS_WORKER',
  SVU_WORKER: 'SVU_WORKER',
  SVU_OWNER: 'SVU_OWNER',
  SVU_CROSS_WORKER: 'SVU_CROSS_WORKER',
  SVU_CROSS_OWNER: 'SVU_CROSS_OWNER',
  GP_BRNO: 'GP_BRNO',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type FlowEnum = ValuesOf<typeof FlowEnum>;

export type FlowEnumRequest = FlowEnum;
export type FlowEnumResponse = FlowEnum;
